// // import React, { useState, useEffect } from 'react';
// // import {
// //   Box,
// //   TextField,
// //   FormControl,
// //   Select,
// //   MenuItem,
// //   Checkbox,
// //   ListItemText,
// // } from '@mui/material';
// // import DownloadIcon from '@mui/icons-material/Download';
// // import EmployeeReportDialog from './EmployeeReportDialog';

// // const ReportFilters = ({
// //   searchTerm,
// //   setSearchTerm,
// //   selectedDifficulties,
// //   setSelectedDifficulties,
// //   selectedExamTypes,
// //   setSelectedExamTypes,
// //   handleExportCSV,
// // }) => {
// //   const [difficulties, setDifficulties] = useState([]);
// //   const [examTypes, setExamTypes] = useState([]);
// //   const [dialogOpen, setDialogOpen] = useState(false);

// //   useEffect(() => {
// //     const fetchOptions = async () => {
// //       try {
// //         const response = await fetch('/reports/filter-options/');
// //         const data = await response.json();
// //         setDifficulties(Object.values(data.difficulties || []));
// //         setExamTypes(Object.values(data.exam_types || []));
// //       } catch (error) {
// //         console.error('Error fetching filter options:', error);
// //       }
// //     };
// //     fetchOptions();
// //   }, []);

// //   const handleDifficultyChange = (event) => {
// //     const value = event.target.value;
// //     setSelectedDifficulties(
// //       typeof value === 'string' ? value.split(',') : value
// //     );
// //   };

// //   const handleExamTypeChange = (event) => {
// //     const value = event.target.value;
// //     setSelectedExamTypes(
// //       typeof value === 'string' ? value.split(',') : value
// //     );
// //   };

// //   const blackBorderStyles = {
// //     height: '40px',
// //     fontSize: '0.875rem',
// //     background: 'white',
// //     '& .MuiOutlinedInput-notchedOutline': {
// //       borderColor: '#000',
// //     },
// //     '&:hover .MuiOutlinedInput-notchedOutline': {
// //       borderColor: '#000',
// //     },
// //     '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
// //       borderColor: '#000',
// //     },
// //   };

// //   return (
// //     <>
// //       <Box
// //         sx={{
// //           display: 'flex',
// //           alignItems: 'center',
// //           justifyContent: 'space-between',
// //           mb: 2,
// //           gap: 2,
// //         }}
// //       >
// //         {/* Left Side */}
// //         <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexGrow: 1 }}>
// //           {/* Search */}
// //           <TextField
// //             variant="outlined"
// //             size="small"
// //             placeholder="Search by Title, Difficulty, Type, Assigned, Enrolled, Pass %"
// //             value={searchTerm}
// //             onChange={(e) => setSearchTerm(e.target.value)}
// //             sx={{
// //               width: 400,
// //               '& .MuiOutlinedInput-root': blackBorderStyles,
// //             }}
// //           />

// //           {/* Difficulty Filter */}
// //           <FormControl sx={{ minWidth: 180 }}>
// //             <Select
// //               multiple
// //               value={selectedDifficulties}
// //               onChange={handleDifficultyChange}
// //               displayEmpty
// //               renderValue={(selected) =>
// //                 selected.length === 0
// //                   ? 'All Difficulties'
// //                   : selected.join(', ')
// //               }
// //               sx={blackBorderStyles}
// //             >
// //               {difficulties.map((level) => (
// //                 <MenuItem key={level} value={level}>
// //                   <Checkbox checked={selectedDifficulties.includes(level)} />
// //                   <ListItemText primary={level} />
// //                 </MenuItem>
// //               ))}
// //             </Select>
// //           </FormControl>

// //           {/* Exam Type Filter */}
// //           <FormControl sx={{ minWidth: 180 }}>
// //             <Select
// //               multiple
// //               value={selectedExamTypes}
// //               onChange={handleExamTypeChange}
// //               displayEmpty
// //               renderValue={(selected) =>
// //                 selected.length === 0
// //                   ? 'All Assessment Types'
// //                   : selected.join(', ')
// //               }
// //               sx={blackBorderStyles}
// //             >
// //               {examTypes.map((type) => (
// //                 <MenuItem key={type} value={type}>
// //                   <Checkbox checked={selectedExamTypes.includes(type)} />
// //                   <ListItemText primary={type} />
// //                 </MenuItem>
// //               ))}
// //             </Select>
// //           </FormControl>
// //         </Box>

// //         {/* Right Side Buttons */}
// //         <Box sx={{ display: 'flex', gap: 2 }}>
// //           <button
// //             className="btn BlueBtn d-flex align-items-center"
// //             onClick={() => setDialogOpen(true)}
// //           >
// //             Report
// //           </button>

// //           <button
// //             className="btn BlueBtn d-flex align-items-center"
// //             onClick={handleExportCSV}
// //           >
// //             <DownloadIcon style={{ marginRight: '6px' }} />
// //             Export CSV
// //           </button>
// //         </Box>
// //       </Box>

// //       <EmployeeReportDialog
// //         open={dialogOpen}
// //         onClose={() => setDialogOpen(false)}
// //       />
// //     </>
// //   );
// // };

// // export default ReportFilters;

// import React, { useState, useEffect, useRef } from 'react';
// import {
//   Box,
//   TextField,
//   Button,
// } from '@mui/material';
// import DownloadIcon from '@mui/icons-material/Download';
// import EmployeeReportDialog from './EmployeeReportDialog';
// import { DropDownList } from '@syncfusion/ej2-dropdowns';

// // Syncfusion QueryBuilder
// import { QueryBuilderComponent } from '@syncfusion/ej2-react-querybuilder';
// import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
// import '@syncfusion/ej2-base/styles/material.css';
// import '@syncfusion/ej2-buttons/styles/material.css';
// import '@syncfusion/ej2-popups/styles/material.css';
// import '@syncfusion/ej2-splitbuttons/styles/material.css';
// import '@syncfusion/ej2-inputs/styles/material.css';
// import '@syncfusion/ej2-lists/styles/material.css';
// import '@syncfusion/ej2-dropdowns/styles/material.css';
// import '@syncfusion/ej2-calendars/styles/material.css';
// import '@syncfusion/ej2-navigations/styles/material.css';
// import '@syncfusion/ej2-querybuilder/styles/material.css';

// const ReportFilters = ({
//   searchTerm,
//   setSearchTerm,
//   setFilterRule,
//   handleExportCSV,
// }) => {
//   const [dialogOpen, setDialogOpen] = useState(false);
//   const [showFilters, setShowFilters] = useState(false);
//   const qbRef = useRef(null);
//   const currentRuleRef = useRef({ condition: 'and', rules: [] });

//   const stringOperators = [
//     { value: 'contains', key: 'Contains' },
//     { value: 'equal', key: 'Equal' },
//     { value: 'notequal', key: 'Not Equal' },
//     { value: 'startswith', key: 'Starts With' },
//     { value: 'endswith', key: 'Ends With' },
//     { value: 'isempty', key: 'Is Empty' },
//     { value: 'isnotempty', key: 'Is Not Empty' }
//   ];

//   const numberOperators = [
//     { value: 'equal', key: 'Equal' },
//     { value: 'notequal', key: 'Not Equal' },
//     { value: 'greaterthan', key: 'Greater Than' },
//     { value: 'lessthan', key: 'Less Than' },
//     { value: 'greaterthanorequal', key: 'Greater Than Or Equal' },
//     { value: 'lessthanorequal', key: 'Less Than Or Equal' }
//   ];

//   const dateOperators = [
//     { value: 'equal', key: 'Equal' },
//     { value: 'notequal', key: 'Not Equal' },
//     { value: 'greaterthan', key: 'After' },
//     { value: 'lessthan', key: 'Before' },
//     { value: 'greaterthanorequal', key: 'On or After' },
//     { value: 'lessthanorequal', key: 'On or Before' },
//     { value: 'between', key: 'Between' },
//     { value: 'isempty', key: 'Is Empty' },
//     { value: 'isnotempty', key: 'Is Not Empty' }
//   ];


//   const queryBuilderColumns = [
//     { field: 'title', label: 'Title', type: 'string', operators: stringOperators },
//     // { field: 'difficulty', label: 'Difficulty', type: 'string', operators: stringOperators },
//     { field: 'exam_type', label: 'Assessment Type', type: 'string', operators: stringOperators },
//     // { field: 'scheduled', label: 'Scheduled', type: 'date', format: 'yyyy-MM-dd', operators: dateOperators },
//     // { field: 'assigned', label: 'Assigned', type: 'string', operators: stringOperators },
//     // { field: 'enrolled', label: 'Enrolled', type: 'number', operators: numberOperators },
//     { field: 'pass_percent', label: 'Pass %', type: 'number', operators: numberOperators },
//   //    {
//   //   field: 'isenable',
//   //   label: 'Is Enable',
//   //   type: 'number',
//   //   operators: [
//   //     { value: 'equal', key: 'Equal' }
//   //   ],
//   //   values: [
//   //     { key: 'Enabled', value: 1 },
//   //     { key: 'Disabled', value: 0 }
//   //   ]
//   // }
// {
//   field: 'isenable',
//   label: 'Is Enable',
//   type: 'string',
//   operators: [
//     { value: 'equal', key: 'Equal' }
//   ],
//   values: ['Yes', 'No']
// }

//   ];
//   const defaultRule = { condition: 'and', rules: [] };

//   const applyFilters = () => {
//     const rule = currentRuleRef.current || defaultRule;
//     setFilterRule(rule);
//   };

//   const clearAllFilters = () => {
//     setSearchTerm('');
//     setFilterRule(null);
//     if (qbRef.current) {
//       qbRef.current.setRules(defaultRule);
//       currentRuleRef.current = defaultRule;
//     }
//   };



//   return (
//     <>
//       <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 2 }}>
//         {/* Top row: search + toggle filters + export buttons */}
//         <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexGrow: 1 }}>
//             <TextField
//               variant="outlined"
//               size="small"
//               placeholder="Search by Title, Assessment Type, Pass %"
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//             <button
//               variant="outlined"
//               className='btn'
//               onClick={() => {
//                 if (showFilters) {
//                   if (qbRef.current) {
//                     qbRef.current.setRules(defaultRule);
//                     currentRuleRef.current = defaultRule;
//                   }

//                   setSearchTerm('');
//                   setFilterRule(null);
//                 }

//                 setShowFilters(!showFilters);
//               }}
//             >
//               {showFilters ? 'Close Filters' : 'Enable Filters'}
//             </button>
//           </Box>

//           <Box sx={{ display: 'flex', gap: 2 }}>
//             <button className="btn " onClick={() => setDialogOpen(true)}>
//               Report
//             </button>
//             {/* <button
//               className="btn"
//               onClick={handleExportCSV}
//               style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: '6px'
//               }}
//             >
//               <DownloadIcon />
//               Export CSV
//             </button> */}

//           </Box>
//         </Box>

//         {/* QueryBuilder (conditionally visible) */}
//         {showFilters && (
//           <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 1, border: '1px solid #ddd' }}>
//             <QueryBuilderComponent
//               ref={qbRef}
//               dataSource={[]}
//               columns={queryBuilderColumns}
//               rule={defaultRule}
//               ruleChange={(args) => { currentRuleRef.current = args.rule; }}
//               created={() => {
//                 if (qbRef.current) qbRef.current.setRules(defaultRule);
//               }}
//               showButtons={false}
//               summaryView={false}
//             />
//             <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
//               <ButtonComponent cssClass="btn-negative" onClick={clearAllFilters}>
//                 Clear Filters
//               </ButtonComponent>
//               <ButtonComponent cssClass="btn" onClick={applyFilters}>
//                 Apply Filters
//               </ButtonComponent>
//             </Box>
//           </Box>
//         )}
//       </Box>

//       <EmployeeReportDialog open={dialogOpen} onClose={() => setDialogOpen(false)} />
//     </>
//   );
// };

// export default ReportFilters;







// viva_ui/src/Reports/ReportFilters.js


import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  TextField,
  Button,
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import EmployeeReportDialog from './EmployeeReportDialog';
import { DropDownList } from '@syncfusion/ej2-dropdowns';

// Syncfusion QueryBuilder
import { QueryBuilderComponent } from '@syncfusion/ej2-react-querybuilder';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import '@syncfusion/ej2-base/styles/material.css';
import '@syncfusion/ej2-buttons/styles/material.css';
import '@syncfusion/ej2-popups/styles/material.css';
import '@syncfusion/ej2-splitbuttons/styles/material.css';
import '@syncfusion/ej2-inputs/styles/material.css';
import '@syncfusion/ej2-lists/styles/material.css';
import '@syncfusion/ej2-dropdowns/styles/material.css';
import '@syncfusion/ej2-calendars/styles/material.css';
import '@syncfusion/ej2-navigations/styles/material.css';
import '@syncfusion/ej2-querybuilder/styles/material.css';

const ReportFilters = ({
  searchTerm,
  setSearchTerm,
  setFilterRule,
  handleExportCSV,
  searchPlaceholder = "Search by Title, Assessment Type, Pass %",
  queryBuilderColumns: customQueryBuilderColumns,
  showReportButton = true,
  showExportCSV = false,
  extraActions = null,
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const qbRef = useRef(null);
  const currentRuleRef = useRef({ condition: 'and', rules: [] });

  const stringOperators = [
    { value: 'contains', key: 'Contains' },
    { value: 'equal', key: 'Equal' },
    { value: 'notequal', key: 'Not Equal' },
    { value: 'startswith', key: 'Starts With' },
    { value: 'endswith', key: 'Ends With' },
    { value: 'isempty', key: 'Is Empty' },
    { value: 'isnotempty', key: 'Is Not Empty' }
  ];

  const numberOperators = [
    { value: 'equal', key: 'Equal' },
    { value: 'notequal', key: 'Not Equal' },
    { value: 'greaterthan', key: 'Greater Than' },
    { value: 'lessthan', key: 'Less Than' },
    { value: 'greaterthanorequal', key: 'Greater Than Or Equal' },
    { value: 'lessthanorequal', key: 'Less Than Or Equal' }
  ];

  const dateOperators = [
    { value: 'equal', key: 'Equal' },
    { value: 'notequal', key: 'Not Equal' },
    { value: 'greaterthan', key: 'After' },
    { value: 'lessthan', key: 'Before' },
    { value: 'greaterthanorequal', key: 'On or After' },
    { value: 'lessthanorequal', key: 'On or Before' },
    { value: 'between', key: 'Between' },
    { value: 'isempty', key: 'Is Empty' },
    { value: 'isnotempty', key: 'Is Not Empty' }
  ];


  const queryBuilderColumns = customQueryBuilderColumns || [
    { field: 'title', label: 'Title', type: 'string', operators: stringOperators },
    // { field: 'difficulty', label: 'Difficulty', type: 'string', operators: stringOperators },
    { field: 'exam_type', label: 'Assessment Type', type: 'string', operators: stringOperators },
    // { field: 'scheduled', label: 'Scheduled', type: 'date', format: 'yyyy-MM-dd', operators: dateOperators },
    // { field: 'assigned', label: 'Assigned', type: 'string', operators: stringOperators },
    // { field: 'enrolled', label: 'Enrolled', type: 'number', operators: numberOperators },
    { field: 'pass_percent', label: 'Pass Percentage', type: 'number', operators: numberOperators },
    //    {
    //   field: 'isenable',
    //   label: 'Is Enable',
    //   type: 'number',
    //   operators: [
    //     { value: 'equal', key: 'Equal' }
    //   ],
    //   values: [
    //     { key: 'Enabled', value: 1 },
    //     { key: 'Disabled', value: 0 }
    //   ]
    // }
    {
      field: 'isenable',
      label: 'IsEnable',
      type: 'string',
      operators: [
        { value: 'equal', key: 'Equal' }
      ],
      values: ['Yes', 'No']
    }

  ];
  const defaultRule = { condition: 'and', rules: [] };

  const applyFilters = () => {
    const rule = currentRuleRef.current || defaultRule;
    setFilterRule(rule);
  };

  const clearAllFilters = () => {
    setSearchTerm('');
    setFilterRule(null);
    if (qbRef.current) {
      qbRef.current.setRules(defaultRule);
      currentRuleRef.current = defaultRule;
    }
  };



  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 2 }}>
        {/* Top row: search + toggle filters + export buttons */}
        {/* <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexGrow: 1 }}>
            <TextField
              variant="outlined"
              size="small"
              placeholder={searchPlaceholder}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            /> */}
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, width: '100%', flexWrap: 'wrap', }}>
          <Box sx={{
            display: 'flex', alignItems: 'center', gap: 2, flex: 1,
            minWidth: 0,
          }}>
            <TextField
              variant="outlined"
             size="small"
             placeholder={searchPlaceholder}             
            value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              sx={{
                width: 300,
                '& .MuiOutlinedInput-root': {
                  height: '40px',
                },
              }}
            />
            <button
              variant="outlined"
              className='btn'
              onClick={() => {
                if (showFilters) {
                  if (qbRef.current) {
                    qbRef.current.setRules(defaultRule);
                    currentRuleRef.current = defaultRule;
                  }

                  setSearchTerm('');
                  setFilterRule(null);
                }

                setShowFilters(!showFilters);
              }}
            >
              {showFilters ? 'Close Filters' : 'Enable Filters'}
            </button>
          </Box>

          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
            {extraActions}
            {/* {showReportButton && (
              <button className="btn " onClick={() => setDialogOpen(true)}>
                Report
              </button>
            )} */}
            {showExportCSV && (
              <button
                className="btn"
                onClick={handleExportCSV}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px'
                }}
              >
                <DownloadIcon />
                Export CSV
              </button>
            )}

          </Box>
        </Box>

        {/* QueryBuilder (conditionally visible) */}
        {showFilters && (
          <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 1, border: '1px solid #ddd' }}>
            <QueryBuilderComponent
              ref={qbRef}
              dataSource={[]}
              columns={queryBuilderColumns}
              rule={defaultRule}
              ruleChange={(args) => { currentRuleRef.current = args.rule; }}
              created={() => {
                if (qbRef.current) qbRef.current.setRules(defaultRule);
              }}
              showButtons={false}
              summaryView={false}
            />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
              <ButtonComponent cssClass="btn-negative" onClick={clearAllFilters}>
                Clear Filters
              </ButtonComponent>
              <ButtonComponent cssClass="btn" onClick={applyFilters}>
                Apply Filters
              </ButtonComponent>
            </Box>
          </Box>
        )}
      </Box>

      <EmployeeReportDialog open={dialogOpen} onClose={() => setDialogOpen(false)} />
    </>
  );
};

export default ReportFilters;
